import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
   title?: string;
};

const ArrowRigth = ({ title = "Icono Flecla", ...props}: Props) => {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            <title>{title}</title>
            <path
                d="M12.5072 9.03395H1.02729C0.736223 9.03395 0.492242 8.9355 0.295345 8.73861C0.0984484 8.54171 0 8.29773 0 8.00667C0 7.7156 0.0984484 7.47162 0.295345 7.27472C0.492242 7.07783 0.736223 6.97938 1.02729 6.97938H12.5072L7.47352 1.94567C7.26806 1.74021 7.16961 1.50051 7.17817 1.22657C7.18673 0.952626 7.29374 0.712925 7.4992 0.507468C7.70466 0.319132 7.94436 0.220683 8.2183 0.212123C8.49224 0.203562 8.73194 0.30201 8.9374 0.507468L15.7175 7.28756C15.8202 7.39029 15.893 7.50158 15.9358 7.62143C15.9786 7.74128 16 7.86969 16 8.00667C16 8.14364 15.9786 8.27205 15.9358 8.3919C15.893 8.51175 15.8202 8.62304 15.7175 8.72577L8.9374 15.5059C8.74906 15.6942 8.51364 15.7884 8.23114 15.7884C7.94864 15.7884 7.70466 15.6942 7.4992 15.5059C7.29374 15.3004 7.19101 15.0564 7.19101 14.7739C7.19101 14.4914 7.29374 14.2474 7.4992 14.042L12.5072 9.03395Z"
                fill="white"
            />
        </svg>
    );
};

export default ArrowRigth;
